import Superscript from "@/components/ui/superscript";
export const keyFacts = [
  {
    title: <>Number of internal migrants</>,
    description: (
      <>
        13.7 million
        <Superscript
          path="https://bbs.portal.gov.bd/sites/default/files/files/bbs.portal.gov.bd/page/b2db8758_8497_412c_a9ec_6bb299f8b3ab/2021-08-11-04-54-154c14988ce53f65700592b03e05a0f8.pdf"
          index="1"
        />{" "}
        lifetime migrants.
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    title: <>Migration trends</>,
    description: (
      <>
        66.2%
        <Superscript
          path="https://cabinet.gov.bd/sites/default/files/files/cabinet.portal.gov.bd/research_corner/9dbddde7_4354_4f17_a256_1a444156b1aa/Determinants%20of%20Internal%20Migration%20Evidence%20from%20Bangladesh.pdf"
          index="2"
        />{" "}
        of all migrants move from rural to urban areas in Bangladesh
      </>
    ),
    icon: "/images/icons/urbanization.png",
  },
  {
    title: <>Key destination areas</>,
    description: (
      <>
        <Superscript path="https://tuengr.com/V11A/11A11F.pdf" index="3" />
        Dhaka, Khulna, Rajshahi{" "}
      </>
    ),
    icon: "/images/icons/destination (2).png",
  },
  {
    title: <>Prominent sectors of employment for migrants</>,
    description: (
      <>
        Ready Made Garment sector
        <Superscript
          path="https://link.springer.com/chapter/10.1007/978-981-13-1537-4_12"
          index="4"
        />{" "}
        (85% are internal migrants
        <Superscript
          path="http://eprints.lse.ac.uk/81677/1/Barriers to labour migration in Bangladesh%E2%80%99s garment sector - IGC.pdf"
          index="5"
        />{" "}
        ), Rickshaw pullers
        <Superscript
          path="https://link.springer.com/chapter/10.1007/978-981-13-1537-4_12"
          index="6"
        />
        , Construction sector
        <Superscript
          path="http://www.rmmru.org/newsite/wp-content/uploads/2021/09/The-Construction-Precariat-Dependence-Domination-and-Labour-in-Dhaka.pdf"
          index="7"
        />
      </>
    ),
    icon: "/images/icons/job.png",
  },
];
export const climateImpacts = [
  {
    description: (
      <>
        Climate migrants in Bangladesh (prediction): 13.3 million internal
        migrants by 2050 as a result of climate change
        <Superscript
          path="https://www.worldbank.org/en/news/feature/2022/10/31/key-highlights-country-climate-and-development-report-for-bangladesh"
          index="10"
        />
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    description: (
      <>
        Top three impacts at source on livelihood are crop loss (73%), wage loss
        (64%) and wage cut (41%), and household impacts are food insecurity
        (92%), health issues (75%) and house damage (47%). (sample size- 1048)
      </>
    ),
    icon: "/images/icons/impact.png",
  },
  {
    description: (
      <>
        Top three impacts at source on livelihood are wage loss (80%) wage cut
        (41%) and job loss (20%), and household impacts are health issues (84%),
        food insecurity (83%), and house damage (38%). (sample size- 615)
      </>
    ),
    icon: "/images/icons/home.png",
  },
];
export const stories = [
  {
    title: "Mother's Resolve: Wading Through Climate Extremes",
    description: "",
    videoPath: "https://youtu.be/PQs_PZYu2cA",
  },
  {
    title: `"Is It Our Sins?": Scrapping in Extreme Climate`,
    description: "",
    videoPath: "https://youtu.be/f3lxFLoweiU",
  },
];

export const partners = [
  {
    link: "#",
    title: "Association for Community Development (ACD)",
    logo: "/images/bangladesh/Association for Community Development (ACD) logo.jpg",
  },
  {
    link: "http://bnsk.org/",
    title: "Bangladesh Nari Sramik Kendra (BNSK)",
    logo: "/images/bangladesh/Bangladesh Nari Sramik Kendra (BNSK) logo.png",
  },
  {
    link: "https://www.karmojibinari.org/",
    title: "Kormojibi Nari",
    logo: "/images/bangladesh/Kormojibi Nari (KN) logo.jpg",
  },
  {
    link: "https://www.okup.org.bd/",
    title: "Ovibashi Kormi Unnayan Program (OKUP)",
    logo: "/images/bangladesh/Ovibashi Kormi Unnayan Program (OKUP) logo.png",
  },
];

export const seo = {
  slug: "/bangladesh",
  metaTitle:
    "Bangladesh | People’s Courage International, South & Southeast Asia",
  metaDescription:
    "PCI operates two initiatives in Bangladesh: Migrants Resilience Collaborative and the climate resilience initiative.",
};

export const jsonLd = {
  "@context": "http://www.schema.org",
  "@type": "Organization",
  name: "People’s Courage International",
  description:
    "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "3206 10th Street NE, Washington",
    addressLocality: "DC",
    postalCode: "20017",
    addressCountry: "USA",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1202-573-8727",
    contactType: "customer support",
  },
};

export const insights = [
  {
    heading:
      "Bangladesh is witnessing rapid increase in rural to urban migration",
    text: `There has been a large increase in rural to urban migration in Bangladesh in the last 15 years.<sup><a href="http://bbs.portal.gov.bd/sites/default/files/files/bbs.portal.gov.bd/page/b2db8758_8497_412c_a9ec_6bb299f8b3ab/2021-08-11-04-54-154c14988ce53f65700592b03e05a0f8.pdf" target="_blank" rel="noreferrer" >[11]</a></sup> This has been driven by urbanisation and the associated boom in the manufacturing sector. Rise in ready-made garment factories has fuelled migration among women<sup><a href="https://www.researchgate.net/publication/259547142_Feminization_and_Labor_Vulnerability_in_Global_Manufacturing_Industries_Does_Gendered_Discourse_Matter" target="_blank" rel="noreferrer" >[12]</a></sup>, who make up 80% of the employees in the sector.<sup><a href="https://waronwant.org/sites/default/files/Stitched%20Up.pdf" target="_blank" rel="noreferrer" >[13]</a></sup>`,
    image: "/images/bangladesh/Banladesh is witnessing.webp",
  },
  {
    heading:
      "Climate change – both slow-onset and extreme events – are fuelling rural to urban migration in Bangladesh :",
    text: `In 2019, climate related impacts led to the displacement of 4.1 million people, and migration of 455,941 mainly due to slow-onset climate change within Bangladesh.<sup><a href="https://www.internal-displacement.org/publications/2020-global-report-on-internal-displacement#:~:text=The%20Global%20Report%20on%20Internal,in%20addressing%20and%20preventing%20displacement" target="_blank" rel="noreferrer" >[14]</a></sup> Further predictions suggest by 2050, the country could have 13.3 million internal climate migrants<sup><a href="https://openknowledge.worldbank.org/entities/publication/2be91c76-d023-5809-9c94-d41b71c25635" target="_blank" rel="noreferrer" >[15]</a></sup>, accounting for a third of all in South Asia.<sup><a href="https://openknowledge.worldbank.org/entities/publication/2c9150df-52c3-58ed-9075-d78ea56c3267" target="_blank" rel="noreferrer" >[16]</a></sup> Major push factors for climate migration are associated with the lack of productivity in agriculture during lean seasons, annual flooding and recurrent food crises. These continue to push vulnerable communities such as farmers and landless labourers in distress to migrate to other regions of Bangladesh, increasing internal migration.<sup><a href="https://direct.mit.edu/adev/article/37/1/1/93293/Seasonal-Poverty-and-Seasonal-Migration-in-Asia" target="_blank" rel="noreferrer" >[17]</a></sup> For example, the northern region is faced with a recurring seasonal event, commonly referred to as ‘monga’ which creates a near-famine situation between the periods of cultivation and harvest, leading to annual labour migration in the region.<sup><a href="https://rsa.tandfonline.com/doi/pdf/10.1080/17565529.2013.833078" target="_blank" rel="noreferrer" >[18]</a></sup>`,
    image: "/images/bangladesh/insight-2.jpg",
  },
  {
    heading:
      "Challenges directly linked to labour laws increase vulnerability of migrant workers:",
    text: `Migrant workers are often paid less and made to work more. For example, there exists a huge gap between the minimum wage and living wage, especially in Dhaka.<sup><a href="https://www.globallivingwage.org/wp-content/uploads/2018/05/Dhaka_Living_Wage_Benchmark_Report.pdf" target="_blank" rel="noreferrer">[19]</a></sup> The current minimum wage in Bangladesh is the lowest in the Asia and Pacific region excluding sectors in which migrant workers are employed such as agriculture and domestic work.<sup><a href="https://www.employment-studies.co.uk/system/files/resources/files/ILO%20Global%20Wage%20Report%202020-21.pdf" target="_blank" rel="noreferrer">[20]</a></sup> The data on the Labour Rights Index also shows that there is a total lack of decent work in the country, suggesting challenges in compliance with the existing labour laws.<sup><a href="https://labourrightsindex.org/lri-2022-documents/bangladesh.pdf" target="_blank" rel="noreferrer">[21]</a></sup> For instance, 50% of the workers in 18 ready-made garment factories exceeded the overtime limit.<sup><a href="https://www.fairlabor.org/projects/toward-fair-compensation-in-bangladesh/ " target="_blank" rel="noreferrer">[22]</a></sup>`,
    image: "/images/bangladesh/insight-3.jpg",
  },
  {
    heading:
      "Design of existing schemes makes it challenging for migrants to access benefits:",
    text: `There are over 142 social security schemes in Bangladesh.<sup><a href="https://publications.iom.int/system/files/pdf/bangladesh-_migof.pdf" target="_blank" rel="noreferrer">[23]</a></sup> However, migrants face challenges in accessing them, primarily due to lack of portability. This is because schemes are designed based on geographical area, making migrants ‘ineligible’ when they move to a different geography for work.<sup><a href="https://www.shram.org/uploadFiles/20170809013520.pdf" target="_blank" rel="noreferrer">[24]</a></sup>`,
    image: "/images/bangladesh/insight-4.jpg",
  },
];
export const learnMore = [
  {
    link: "https://cabinet.gov.bd/sites/default/files/files/cabinet.portal.gov.bd/research_corner/9dbddde7_4354_4f17_a256_1a444156b1aa/Determinants%20of%20Internal%20Migration%20Evidence%20from%20Bangladesh.pdf",
    text: "Determinants of Internal Migration: Evidence from Bangladesh",
  },
  {
    link: "https://link.springer.com/chapter/10.1007/978-981-13-1537-4_12",
    text: "Internal Migration, Urbanization and Poverty in Asia: Dynamics and Interrelationships",
  },
  {
    link: "https://www.rmmru.org/newsite/wp-content/uploads/2021/09/The-Construction-Precariat-Dependence-Domination-and-Labour-in-Dhaka.pdf",
    text: "The Construction Precariat: Dependence, Domination and Labour in Dhaka",
  },
];
